import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../Assets/Logo/virtuosoft-logo-2x.png";
import styled from "styled-components";
import { MenuButton } from "../MenuBUtton";
import { COLORS } from "../../Constants/colors";

const PRIMARY_COLOR = COLORS.primary;
const TEXT_COLOR = COLORS.textPrimary;

const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${COLORS.background};
  padding: 0 40px;
  height: 80px;
  position: sticky;
  top: 0;
  z-index: 2000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const NavLinks = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 1028px) {
    flex-direction: column;
    position: fixed;
    top: 64px;
    left: 0;
    width: 100%;
    height: calc(100vh - 62px);
    background-color: ${COLORS.background};
    padding: 0;
    padding-top: 30px;
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    align-items: center;
    z-index: 1000;
  }
`;

const NavLink = styled.li`
  cursor: pointer;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: ${TEXT_COLOR};
  transition: color 0.3s ease;

  &:hover,
  &.active {
    color: ${PRIMARY_COLOR};
  }

  &.active::after,
  &:hover::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: ${PRIMARY_COLOR};
  }
`;

const ContactLink = styled.li`
  list-style: none;
  background-color: transparent;
  border: 1.5px solid ${PRIMARY_COLOR};
  color: ${PRIMARY_COLOR};
  border-radius: 50px;
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${PRIMARY_COLOR};
    color: ${COLORS.buttonText};
  }

  @media screen and (max-width: 1028px) {
    display: none;
  }
`;

const ContactButtonMobile = styled(ContactLink)`
  display: none;
  @media screen and (max-width: 1028px) {
    display: block;
  }
`;

const Burger = styled.div`
  display: none;
  cursor: pointer;
  @media screen and (max-width: 1028px) {
    display: block;
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("/");
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   setActiveLink(window.location.pathname);
  // }, []);

  useEffect(() => {
    const path = location.pathname.replace(/^\/test/, '') || '/';
    // setActiveLink(path);
    const fullPath = path + (location.hash || ""); // include hash if present
    setActiveLink(fullPath);
  }, [location.pathname, location.hash]);

  // useEffect(() => {
  //   const path = window.location.pathname.replace(/^\/test/, '') || '/';
  //   setActiveLink(path);
  // }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const handleNavigate = (path) => {
    if(path === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    // setActiveLink(path);
    setActiveLink(path.replace(/^\/test/, '') || '/');
    navigate(path);
    setIsOpen(false);
  };
  

  return (
    <NavbarContainer>
      <img
        src={logo}
        alt="Virtuosoft-Logo"
        style={{ cursor: "pointer", width: "160px", height: "36px" }}
        onClick={() => handleNavigate("/")}
      />
      <NavLinks isOpen={isOpen}>
        {[
          { label: "Home", path: "/" },
          { label: "AI", path: "/ai" },
          { label: "FinTech", path: "/fintech" },
          {label: "Projects", path: "/#projects"},
          { label: "Services", path: "/#services" },
          { label: "Products", path: "/products" },
          {label: "Expertise", path: "/#expertise"},
          { label: "About", path: "/#about-us" },
          // { label: "Achievements", path: "/achievements" },
        ].map(({ label, path }, idx) => (
          <NavLink
            key={idx}
            className={activeLink === path ? "active" : ""}
            onClick={() => handleNavigate(path)}
          >
            {label}
          </NavLink>
        ))}
        <ContactButtonMobile onClick={() => handleNavigate("/contact-us")}>Contact Us</ContactButtonMobile>
      </NavLinks>
      <ContactLink onClick={() => handleNavigate("/contact-us")}>Contact Us</ContactLink>
      <Burger>
        <MenuButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
      </Burger>
    </NavbarContainer>
  );
};

export default Navbar;

